import { defineMessages } from "@/i18n";
import en from "./en";

export const agentActivityDesktopMessages = defineMessages(
  "agent-activity-desktop",
  en,
);
